import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Room } from '../model/room';
import { Search } from '../model/search';
import { Empresa } from '../model/empresa';
import { MotorService } from '../services/motor.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  room: Room;
  search: Search;
  tarifaPernoite: number;
  form: any;
  public empresa: Empresa;

  constructor(
    private readonly router: Router,
    private readonly motorService: MotorService
  ) {
    this.form = this.router.getCurrentNavigation().extras.state.dados.form;
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
    this.room = this.router.getCurrentNavigation().extras.state.dados.room;
    this.search = this.router.getCurrentNavigation().extras.state.dados.search;
    this.tarifaPernoite = this.router.getCurrentNavigation().extras.state.dados.tarifaPernoite;
    console.log('this.empresa.token_motor', this.empresa.token_motor);
  }

  novaReserva() {
    this.router.navigate(["company", this.empresa.token_motor, 'search'], {state: {
    }});
  }
 
  ngOnInit() {}
}
